export { default as definitions } from './message-definitions';

const subscriptions = {};

export const emit = (definition, data) => {
  const listeners = subscriptions[definition.name];
  if (listeners) {
    listeners.map((listener) => listener(data));
  }
};

export const subscribe = (definition, callback) => {
  subscriptions[definition.name] = subscriptions[definition.name] || [];
  subscriptions[definition.name].push(callback);
  return callback;
};

export const unsubscribeAll = (listeners) => {
  const remove = (listener) => {
    Object.keys(subscriptions).forEach((name) => {
      subscriptions[name] = subscriptions[name].filter(
        (thisListener) => thisListener !== listener,
      );
    });
  };
  listeners.map((listener) => remove(listener));
};

export const initialize = () => {};
